'use client';

import type { SlotLinkProps } from '../Base/Slot.Link';
import { useLocaleSwitch } from '../../shared/useLocaleSwitch';
import { SlotLink } from '../Base/Slot.Link';

export type LocaleSwitchSlotProps = Pick<SlotLinkProps, 'priority'>;

/** Locale Switch slot with list of helpers in popover */
export const LocaleSwitchSlot = (props: LocaleSwitchSlotProps) => {
  const { label, href, targetLanguage, switchLocale, isSwitching } = useLocaleSwitch();

  return (
    <SlotLink
      {...props}
      label={label}
      href={href ?? '#'}
      onClick={switchLocale}
      language={targetLanguage}
      isBusy={isSwitching}
    >
      <span className="icon-emp-language-switch size-4" />
    </SlotLink>
  );
};
